import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

user:any;
  constructor(private router: Router) {}

  canActivate(): boolean {
    this.user = localStorage.getItem('trc_user');
    this.user = JSON.parse(this.user);

    if (this.user) {
      return true;
    } else {
      this.router.navigate(['/login']); // Redirect to the login page if not logged in
      return false;
    }
  }
}
